import "@babel/polyfill";
import "details-polyfill";
import React from "react";
import { hydrate } from "react-dom";
import {
  Footer,
  Header,
  InfoBanner,
  updateStateWithClientData,
  WelcomeMessage
} from "./Root";
import startCheckSameSiteIframe from "./sameSiteCookie";
import "./reactAxe";
import { asosGlobalNamespace } from "../template/constants";

document.addEventListener("DOMContentLoaded", function() {
  const headerElement = document.getElementById("chrome-header");
  const footerElement = document.getElementById("chrome-footer");
  const welcomeMessageElement = document.getElementById("chrome-welcome-mat");
  const infoBanner = document.getElementById("chrome-info-banner");

  hydrate(<Header />, headerElement);
  hydrate(<Footer />, footerElement);
  hydrate(<WelcomeMessage />, welcomeMessageElement);
  hydrate(<InfoBanner />, infoBanner);

  window[asosGlobalNamespace].eventBus.emit("hydrate-ready");
  updateStateWithClientData();
});

startCheckSameSiteIframe();
